<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    v-if="font != null"
>
    <v-card>
        <v-card-title>Edit Font</v-card-title>

        <v-card-text>
            <v-text-field
                label="Label"
                v-model="font.label"
            />

            <v-select
                label="Fallback"
                v-model="font.fall_back"
                :items="['serif','sans-serif', 'monospace', 'cursive', 'fantasy']"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            font: null,
        }
    },

    methods: {

        showDialog(font)
        {
            this.font = _.cloneDeep(font);
            this.dialog = true;
        },

        onOk()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/font',
            
                'params' : this.font,
            
                'on_success': (data) => {
                        this.$emit('ok');
                    },
            
                'on_error': 'Unable to save changes to font',
            });
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>